export default function captureEmailLeadEvent() {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'NewEmailLead'
        });
    }
}